import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const RTL_LANGS = ["ar", "ku"];

const applyDirection = (language) => {
  const dir = RTL_LANGS.includes(language) ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", language);
};

const changeLanguage = (language) => {
  i18n.changeLanguage(language);
  applyDirection(language);
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["ar", "en", "ku"],
    fallbackLng: { ku: ["en"], default: ["en"] },
    interpolation: { escapeValue: false },
  });

i18n.on("languageChanged", applyDirection);
applyDirection(i18n.language || localStorage.getItem("selectedLanguage") || "en");

// eslint-disable-next-line import/no-anonymous-default-export
export default { changeLanguage, i18n };
